var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessmentSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111.984,
    height: 111.984,
    x: 4.884,
    y: 4.883,
    fill: "#dff4d4",
    rx: 55.992
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 79.607,
    height: 79.607,
    x: 21.073,
    y: 21.078,
    fill: "#c3e8b0",
    rx: 39.804
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 59.727,
    height: 59.727,
    x: 31.013,
    y: 31.016,
    fill: "#56a42f",
    rx: 29.864
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m68.876 54.875-11 11-5-5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentSuccess);
export default __webpack_public_path__ + "static/media/assessment-success.7e91652c00c07dd3ac32a67fe9567c8a.svg";
export { ForwardRef as ReactComponent };